// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__32AJQ","savePackageButton":"ClientWallet_savePackageButton__2mSpK"};